import * as React from "react";

export const EyeOffIcon = (props) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" {...props}>
    <g
      clipPath="url(#a)"
      stroke="#8888B5"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14.1 14.1A3 3 0 1 1 10 10m8 8a10 10 0 0 1-6 2c-7 0-11-8-11-8 1.2-2.3 3-4.3 5-6l12 12ZM10 4.2l2-.2c7 0 11 8 11 8-.6 1.1-1.3 2.2-2.2 3.2L10 4.2ZM1 1l22 22" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
